export default __webpack_public_path__ + "static/single-leave-02-b9108ea2f1285494b726ffb82c6234a4.png";